import { ApiClient } from "../ApiClient";

/**
 * Submit or update professional license information
 * @param {string} url - The dynamic endpoint path
 * @param {Object} queryData - The license data payload
 * @returns {Promise<Response>} The raw fetch response
 */
export const submitLicense = async (url, queryData) => {
  // ApiClient.put handles baseUrl, CSRF token, and JSON stringification.
  // It returns the raw Response to maintain compatibility with the calling component.
  return ApiClient.put(url, queryData);
};
